// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y2Acd","option":"styles_option__30_Bs","selected":"styles_selected__2rFSr"};